import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from './services/auth.service';
import { tap } from 'rxjs/operators';
import { TokenService } from '../app/services/token.service';
import { ConfigService } from './services/config.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private tokenService: TokenService,
    private authService: AuthService,
    private configService: ConfigService
  ) {}

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // A signed upload PUT goes to the storage bucket, which is neither ours nor
    // interested in the session; sending the token there would leak it.
    if (!this.isApiRequest(req.url)) {
      return next.handle(req);
    }

    const authData = this.tokenService.authData.value;

    if (authData) {
      const headers = {
        'access-token': authData.accessToken,
        client: authData.client,
        expiry: authData.expiry,
        'token-type': authData.tokenType,
        uid: authData.uid,
      };

      req = req.clone({
        setHeaders: headers,
      });
    }

    return next.handle(req).pipe(
      tap(
        res => this.handleResponse(res),
        err => this.handleResponse(err)
      )
    );
  }

  private isApiRequest(url: string): boolean {
    const tenantBaseUrl = this.configService.tenant.value?.base_url;

    return (
      !/^https?:\/\//i.test(url) ||
      url.startsWith(environment.BASE_API_URL) ||
      (!!tenantBaseUrl && url.startsWith(tenantBaseUrl))
    );
  }

  private handleResponse(
    res: HttpResponse<any> | HttpErrorResponse | HttpEvent<any>
  ): void {
    if (res instanceof HttpResponse || res instanceof HttpErrorResponse) {
      if (res.status === 401) {
        this.tokenService.clearAuthData();
        this.authService.goToLoginRequest.next();
        this.authService.logout();
      }

      this.tokenService.getAuthHeadersFromResponse(res);
    }
  }
}
